import { memo } from 'react';
import { Upload } from 'antd';
import { useUploadChildSummaryMutation } from '@/services/child-api';
import { UploadSvg } from '@/assets/icons';
import Button from '@/components/button';

const SummaryUploader = ({ childId, onUpload }) => {
  const [uploadSummary, { isLoading }] = useUploadChildSummaryMutation();

  const upload = async (info) => {
    const body = new FormData();
    body.append('file', info.file);
    try {
      await uploadSummary({ childId, body }).unwrap();
      onUpload();
    } catch (err) {}
  };

  return (
    <Upload showUploadList={false} beforeUpload={() => false} maxCount={1} onChange={upload}>
      <Button type="link" icon={<UploadSvg />} loading={isLoading}>
        Upload Child Summary
      </Button>
    </Upload>
  );
};

export default memo(SummaryUploader);
